export const UserType = {
  GUEST: "GUEST",
  PATIENT: "PATIENT",
  ANONYMOUS: "ANONYMOUS",
};
